import axios from 'axios';

let originalAdapter = null;

// Today's date so calendar meeting dots land in the current month
const TODAY = new Date();
const THIS_MONTH_DATE = (d) =>
  `${TODAY.getFullYear()}-${String(TODAY.getMonth() + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}T10:00:00Z`;

const MOCK_DB = {
  projects: [
    { id: 1, uuid: 'p-test-1', name: 'Test Project Alpha', description: 'Mock project for visual tests', completed_steps: [0] },
    { id: 2, uuid: 'p-test-2', name: 'Test Project Beta', description: 'Second mock project', completed_steps: [] },
    { id: 3, uuid: 'p-test-3', name: 'Test Project Gamma', description: 'Third mock project', completed_steps: [0, 1] },
  ],
  meetings: [
    { uuid: 'm-test-1', name: 'Alpha Team Meeting', title: 'Alpha Team Meeting', date: THIS_MONTH_DATE(5), created_at: THIS_MONTH_DATE(5), status: 'Processed', duration: 3600, text_summary: 'Discussed quarterly goals and roadmap planning.', project: { uuid: 'p-test-1', name: 'Test Project Alpha' } },
    { uuid: 'm-test-2', name: 'Beta Sprint Review', title: 'Beta Sprint Review', date: THIS_MONTH_DATE(12), created_at: THIS_MONTH_DATE(12), status: 'Processed', duration: 1800, text_summary: 'Reviewed sprint velocity and backlog priorities.', project: { uuid: 'p-test-2', name: 'Test Project Beta' } },
    { uuid: 'm-test-3', name: 'Gamma Kickoff', title: 'Gamma Kickoff', date: THIS_MONTH_DATE(20), created_at: THIS_MONTH_DATE(20), status: 'Not processed', duration: 3600, text_summary: '', project: { uuid: 'p-test-3', name: 'Test Project Gamma' } },
  ],
  tasks: [
    { uuid: 't-1', id: 1, title: 'Write introduction', status: { name: 'In Progress' }, project: { uuid: 'p-test-1', name: 'Test Project Alpha' }, user: { id: 1, name: 'Alice Test' } },
    { uuid: 't-2', id: 2, title: 'Collect survey data', status: { name: 'To Do' }, project: { uuid: 'p-test-2', name: 'Test Project Beta' }, user: { id: 2, name: 'Bob Test' } },
    { uuid: 't-3', id: 3, title: 'Analyse transcripts', status: { name: 'Done' }, project: { uuid: 'p-test-3', name: 'Test Project Gamma' }, user: { id: 1, name: 'Alice Test' } },
    { uuid: 't-4', id: 4, title: 'Code interviews', status: { name: 'In Progress' }, project: { uuid: 'p-test-1', name: 'Test Project Alpha' }, user: { id: 2, name: 'Bob Test' } },
  ],
  conversations: [
    { uuid: 'c-1', title: 'Research design discussion', unread_count: 3, notes_count: 5, latest_note: { content: 'Agreed on methodology', created_at: new Date().toISOString(), user: { name: 'Alice Test' } }, project: { uuid: 'p-test-1', name: 'Test Project Alpha' } },
    { uuid: 'c-2', title: 'Data collection plan', unread_count: 0, notes_count: 2, latest_note: { content: 'Survey ready to send', created_at: new Date().toISOString(), user: { name: 'Bob Test' } }, project: { uuid: 'p-test-2', name: 'Test Project Beta' } },
    { uuid: 'c-3', title: 'Coding scheme review', unread_count: 1, notes_count: 8, latest_note: { content: 'New category proposed', created_at: new Date().toISOString(), user: { name: 'Alice Test' } }, project: { uuid: 'p-test-3', name: 'Test Project Gamma' } },
  ],
  team: {
    members: [
      { id: 1, name: 'Alice Test', email: 'alice@test.com', role: 'admin' },
      { id: 2, name: 'Bob Test', email: 'bob@test.com', role: 'member' },
    ],
  },
  plans: [
    { id: 'basic', name: 'Basic', price: 0, features: ['5 projects'] },
    { id: 'pro', name: 'Pro', price: 29, features: ['Unlimited projects', 'AI analysis'] },
  ],
  flowStatus: {
    current_step: 0,
    completed_steps: [],
  },
  researchQuestions: [
    { uuid: 'rq-1', question: 'What are the main factors affecting qualitative research outcomes?', type: 'manual', status: 'active', created_at: new Date().toISOString(), user: { name: 'Alice Test' }, credits_used: 0 },
    { uuid: 'rq-2', question: 'How does participant selection impact data validity?', type: 'ai_generated', status: 'draft', created_at: new Date().toISOString(), user: { name: 'Bob Test' }, credits_used: 5 },
  ],
  researchGoals: [
    { uuid: 'rg-1', general_goal: 'To investigate the relationship between methodology and research quality', specific_goals: ['Understand coding schemes', 'Measure inter-rater reliability'], status: 'active', type: 'manual', created_at: new Date().toISOString(), user: { name: 'Alice Test' }, credits_used: 0 },
  ],
  researchHypotheses: [
    { uuid: 'rh-1', hypothesis_text: 'Structured coding schemes lead to higher inter-rater reliability than ad-hoc approaches', hypothesis_type: 'general', status: 'draft', type: 'manual', created_at: new Date().toISOString(), user: { name: 'Alice Test' }, credits_used: 0 },
  ],
  methodologies: [
    { uuid: 'met-1', methodology_type: 'qualitative', research_design: 'Case study', data_collection: 'Semi-structured interviews', analysis_approach: 'Thematic analysis', status: 'active', type: 'manual', created_at: new Date().toISOString(), user: { name: 'Alice Test' }, credits_used: 0 },
  ],
  characterizations: [
    { uuid: 'char-1', id: 1, universe: 'All university students in Portugal', population: 'Computer science students in Lisbon', sample: '30 students from IST', sampling_type: 'purposive', sample_size: 30, status: 'active', type: 'manual', created_at: new Date().toISOString(), user: { name: 'Alice Test' }, credits_used: 0 },
  ],
  questionnaires: [
    { uuid: 'qn-1', title: 'Research Experience Survey', description: 'A survey about research methodology experience', status: 'active', questions_count: 5, total_responses: 10, completion_rate: 80, created_at: new Date().toISOString(), creator: { name: 'Alice Test' } },
    { uuid: 'qn-2', title: 'Post-Interview Feedback', description: 'Feedback form for participants', status: 'draft', questions_count: 3, total_responses: 0, completion_rate: 0, created_at: new Date().toISOString(), creator: { name: 'Bob Test' } },
  ],
  analysis: [
    { uuid: 'an-1', name: 'Alpha Team Meeting Analysis', created_at: new Date().toISOString(), status: 'Processed', meeting: { uuid: 'm-test-1', name: 'Alpha Team Meeting' } },
    { uuid: 'an-2', name: 'Beta Sprint Review Analysis', created_at: new Date().toISOString(), status: 'Processed', meeting: { uuid: 'm-test-2', name: 'Beta Sprint Review' } },
  ],
  pipelines: [
    {
      id: 1, uuid: 'pip-1', name: 'Qualitative Study Pipeline', status: 'completed',
      research_description: 'Automated analysis of interview transcripts using AI',
      steps: [
        { step_name: 'transcription', status: 'completed', result: null },
        { step_name: 'analysis', status: 'completed', result: null },
      ],
      project: { name: 'Test Project Alpha', color: '#3b82f6', description: 'Main project' },
      created_at: new Date().toISOString(),
    },
    {
      id: 2, uuid: 'pip-2', name: 'Video Processing Pipeline', status: 'processing',
      research_description: 'Processing video interviews for emotion analysis',
      steps: [
        { step_name: 'transcription', status: 'completed', result: null },
        { step_name: 'emotion_analysis', status: 'processing', result: null },
      ],
      project: { name: 'Test Project Beta', color: '#10b981', description: 'Beta project' },
      created_at: new Date().toISOString(),
    },
  ],
};

function matchUrl(url, pattern) {
  return url && url.includes(pattern);
}

function getMockData(url) {
  // Order matters — more specific patterns first

  // Project flow status
  if (matchUrl(url, '/flow-status')) return MOCK_DB.flowStatus;
  if (matchUrl(url, '/flow-step/')) return { success: true, completed_steps: MOCK_DB.flowStatus.completed_steps, current_step: MOCK_DB.flowStatus.current_step };

  // Project dashboard (consolidated)
  if (matchUrl(url, '/project/') && matchUrl(url, '/dashboard')) {
    return {
      project: { ...MOCK_DB.projects[0], analysis: [], subjects: [], property_definitions: [] },
      tasks: MOCK_DB.tasks.filter(t => t.project.uuid === 'p-test-1'),
      conversations: MOCK_DB.conversations.filter(c => c.project.uuid === 'p-test-1'),
      meetings: MOCK_DB.meetings.filter(m => m.project.uuid === 'p-test-1'),
    };
  }

  // Team / global dashboard
  if (matchUrl(url, '/team/') && matchUrl(url, '/dashboard')) {
    return {
      projects: MOCK_DB.projects,
      tasks: MOCK_DB.tasks,
      conversations: MOCK_DB.conversations,
      meetings: MOCK_DB.meetings,
    };
  }

  // Text codes
  if (matchUrl(url, '/text-codes/')) return [];

  // Single questionnaire (must come before /questionnaires list)
  if (matchUrl(url, '/questionnaire/') && !matchUrl(url, '/questionnaires')) return { questionnaire: MOCK_DB.questionnaires[0] };

  // Questionnaires — component expects { data: [...] }
  if (matchUrl(url, '/questionnaires')) return { data: MOCK_DB.questionnaires };

  // Research endpoints
  if (matchUrl(url, '/research-questions')) return { data: MOCK_DB.researchQuestions };
  if (matchUrl(url, '/research-goals')) return { data: MOCK_DB.researchGoals };
  if (matchUrl(url, '/research-hypotheses')) return { data: MOCK_DB.researchHypotheses };
  if (matchUrl(url, '/research-methodologies')) return { data: MOCK_DB.methodologies };
  if (matchUrl(url, '/characterization')) return { data: MOCK_DB.characterizations };

  // Articles — getArticles returns the full axios response, component reads res.data.articles
  if (matchUrl(url, '/articles')) return { articles: [] };

  // Video conferences
  if (matchUrl(url, '/conferences')) return [];

  // Projects list
  if (matchUrl(url, '/projects/')) return MOCK_DB.projects;

  // Single project (no sub-resource)
  if (matchUrl(url, '/project/') && !matchUrl(url, '/calendar') && !matchUrl(url, '/deletion')) {
    return { ...MOCK_DB.projects[0], analysis: [], subjects: [], property_definitions: [] };
  }

  if (matchUrl(url, '/meetings')) return MOCK_DB.meetings;
  if (matchUrl(url, '/meeting/')) return MOCK_DB.meetings[0];
  if (matchUrl(url, '/members')) return MOCK_DB.team.members;
  if (matchUrl(url, '/plans')) return MOCK_DB.plans;
  if (matchUrl(url, '/user/teams')) return [{ uuid: 't-1', name: 'Test Team', members: [] }];
  if (matchUrl(url, '/statistics')) return { credits_used: 10, credits_total: 100 };
  if (matchUrl(url, '/get_credits')) return { credits: 90 };
  if (matchUrl(url, '/tier')) return { tier: 'basic' };
  if (matchUrl(url, '/all_analysis')) return MOCK_DB.analysis;
  if (matchUrl(url, '/credit-usage-logs')) return { data: [] };
  if (matchUrl(url, '/purchase-entries')) return { data: [] };
  if (matchUrl(url, '/research-pipeline')) return { success: true, pipelines: MOCK_DB.pipelines };
  if (matchUrl(url, '/user')) return { id: 1, name: 'Test User', email: 'test@test.com' };
  return {};
}

export function enableMocking() {
  if (originalAdapter) return;
  originalAdapter = axios.defaults.adapter;

  axios.defaults.adapter = (config) => {
    return new Promise((resolve) => {
      const data = getMockData(config.url);
      setTimeout(() => {
        resolve({
          data,
          status: 200,
          statusText: 'OK',
          headers: { 'content-type': 'application/json' },
          config,
          request: {},
        });
      }, 30);
    });
  };
}

export function disableMocking() {
  if (originalAdapter) {
    axios.defaults.adapter = originalAdapter;
    originalAdapter = null;
  }
}

export { MOCK_DB };
